"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var color_1 = __importDefault(require("color"));
var react_konva_utils_1 = require("react-konva-utils");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var hooks_1 = require("../../hooks");
var STROKE_COLOR = (0, color_1.default)("#cbdbe7");
var STROKE_COLOR_HEX = STROKE_COLOR.hex();
var CHECKED_COLOR_BASE = (0, color_1.default)("#4299e1");
var DARKENED_STROKE_COLOR_HEX = STROKE_COLOR.darken(0.25).hex();
var CHECKED_COLOR = CHECKED_COLOR_BASE.hex();
var CHECKED_HOVERED_COLOR = CHECKED_COLOR_BASE.darken(0.25).hex();
var GanntListItemCheckbox = function (_a) {
    var checked = _a.checked, height = _a.height, width = _a.width, left = _a.x, top = _a.y, onToggle = _a.onToggle;
    var _b = (0, hooks_1.useHover)(), ref = _b[0], isHovered = _b[1];
    var fill = checked
        ? isHovered
            ? CHECKED_HOVERED_COLOR
            : CHECKED_COLOR
        : STROKE_COLOR_HEX;
    var hoveredColor = isHovered ? DARKENED_STROKE_COLOR_HEX : STROKE_COLOR_HEX;
    var color = checked ? fill : hoveredColor;
    var icon = checked ? pro_solid_svg_icons_1.faCheckSquare : pro_light_svg_icons_1.faSquare;
    return ((0, jsx_runtime_1.jsx)(react_konva_utils_1.Html, { children: (0, jsx_runtime_1.jsx)("button", __assign({ ref: ref, className: "absolute flex items-center justify-center", style: {
                width: width,
                height: height,
                top: top,
                left: left,
            }, onClick: onToggle }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "lg", color: color }, void 0) }), void 0) }, void 0));
};
/**
 *  <Rect
      ref={ref}
      x={x}
      y={y}
      width={width}
      height={height}
      fill={fill}
      stroke={stoke}
      strokeWidth={1}
      cornerRadius={1}
    />
 */
exports.default = GanntListItemCheckbox;
